/**
 * <s-bm-intro>
 * Bat Mitzvah page entrance ("the gold gates"): gates swing open onto the page.
 *   [data-intro]        the full-screen overlay (timeline lives in config/styles.css, .bm-intro* / .bm-gate*).
 *   data-bm-intro attr  on this element runs the hero reveal; removed when the intro is skipped.
 * Plays on every visit. Click, Enter, Space or Escape skips it. Skipped for reduced-motion shoppers.
 * Add ?intro=1 to the URL to force it to play (for previewing); this also overrides reduced motion.
 */
class SBmIntro extends HTMLElement {
  connectedCallback() {
    this.overlay = this.querySelector('[data-intro]');
    if (!this.overlay) return;

    const force = new URLSearchParams(window.location.search).has('intro');
    if (force) this.classList.add('bm-force');

    // Plays on every visit (Jillian, Oct 20 2026). Reduced-motion shoppers go straight to the page.
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!force && reduce) {
      this.finish(true);
      return;
    }

    this.skip = () => this.finish(true);
    this.handleKey = (event) => {
      if (event.key === 'Escape' || event.key === 'Enter' || event.key === ' ') this.skip();
    };
    this.handleEnd = (event) => {
      if (event.target === this.overlay && event.animationName === 'bm-intro-out') this.finish(false);
    };
    this.overlay.addEventListener('click', this.skip);
    this.overlay.addEventListener('animationend', this.handleEnd);
    this.ownerDocument.addEventListener('keydown', this.handleKey);
  }

  disconnectedCallback() {
    if (this.handleKey) this.ownerDocument.removeEventListener('keydown', this.handleKey);
  }

  finish(skipReveal) {
    if (skipReveal) this.removeAttribute('data-bm-intro');
    if (this.handleKey) this.ownerDocument.removeEventListener('keydown', this.handleKey);
    if (this.overlay) this.overlay.remove();
    this.overlay = null;
  }
}

if (!customElements.get('s-bm-intro')) customElements.define('s-bm-intro', SBmIntro);
